
/**
 * Array of cancel reasons.
 * @type {Array<{ value: string, label: string }>}
 */
const cancelReasons = [
  {
    value: 'not_paid',
    label: 'Sin pago'
  },
  {
    value: 'no_card',
    label: 'Sin tarjeta de crédito o débito'
  },
  {
    value: 'fraud_review_failed',
    label: 'Revisión de fraude fallida'
  },
  {
    value: 'non_compliant_customer',
    label: 'Cliente no conforme'
  },
  {
    value: 'shutdown_ops',
    label: 'Cierre de operaciones'
  },
  {
    value: 'insolvency',
    label: 'Insolvencia'
  },
  {
    value: 'not_specified',
    label: 'No especificado'
  }
]

/**
 * Array of schedules using UTC-0 time
 * and collection scheme & status subscription
 * @type {Array<{ collectionScheme: string, hour: string, subscriptionStatus: string }>}
 */
const schedules = [
  {
    collectionScheme: 'send_invoice',
    hour: '09:20',
    subscriptionStatus: 'active'
  },
  {
    collectionScheme: 'charge_payment',
    hour: '10:20',
    subscriptionStatus: 'active'
  },
  {
    collectionScheme: 'send_invoice',
    hour: '13:35',
    subscriptionStatus: 'active'
  },
  {
    collectionScheme: 'charge_payment',
    hour: '14:35',
    subscriptionStatus: 'active'
  },
  {
    collectionScheme: 'send_invoice',
    hour: '16:15',
    subscriptionStatus: 'active'
  },
  {
    collectionScheme: 'charge_payment',
    hour: '17:15',
    subscriptionStatus: 'active'
  },
  {
    collectionScheme: null,
    hour: '18:10',
    subscriptionStatus: 'needs_attention'
  },
  {
    collectionScheme: 'send_invoice',
    hour: '20:25',
    subscriptionStatus: 'active'
  },
  {
    collectionScheme: 'charge_payment',
    hour: '21:25',
    subscriptionStatus: 'active'
  },
  {
    collectionScheme: null,
    hour: '22:10',
    subscriptionStatus: 'needs_attention'
  },
  {
    collectionScheme: 'send_invoice',
    hour: '23:45',
    subscriptionStatus: 'active'
  }
]

/**
 * Array of pause reasons.
 * @type {Array<{ value: string, label: string }>}
 */
const pauseReasons = [
  {
    value: 'not_specified',
    label: 'No especificado'
  },
  {
    value: 'non_compliant_customer',
    label: 'Cliente no conforme'
  },
  {
    value: 'custom',
    label: 'Otro'
  }
]

export {
  cancelReasons,
  pauseReasons,
  schedules
}